 
<h2 mat-dialog-title>Please Select a Service</h2>

<mat-dialog-content>

  <div style="padding-bottom:20px">
  
    <div class="row" *ngFor="let service of data.services">
    
        <div class="col-sm-12">
          <div class="link" (click)="selectService(service)">{{service.Name}}</div> 
        </div> 

    </div>

</div>

</mat-dialog-content>